import LayerHeaderMap from './LayerHeaderMap'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    regionsData: state.REGIONS.regionsData,
    selectedRegionId: state.REGIONS.selectedRegionId
  }
}

export default connect(mapStateToProps)(LayerHeaderMap)



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/LayerHeaderMap/index.js